/* eslint-disable */

<template>
  <div>

    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row " :class="{'cursor-drag' : draggingCard === true}">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-base">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="wordBank">
              <h5 class="dragBlock my-4 font-semibold cursor-pointer-simulation ">Standard Naming Convention</h5>
              <h5 class="dragBlock my-4 font-semibold cursor-pointer-simulation ">Permission Auditing and Review</h5>
              <h5 class=" dragBlock my-4 font-semibold cursor-pointer-simulation ">Time of Day Restrictions</h5>
              <h5 class="dragBlock my-4 font-semibold cursor-pointer-simulation ">Usage Auditing and Review</h5>
              <h5 class=" dragBlock my-4 font-semibold cursor-pointer-simulation ">Group Policy</h5>
              <h5 class=" dragBlock my-4 font-semibold cursor-pointer-simulation ">Group-Based Access Control</h5>
              <h5 class=" dragBlock my-4 font-semibold cursor-pointer-simulation ">Off-Boarding Procedures</h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="fourth-sim pt-0">
              <div class="vx-row mb-4">
                <div class="vx-col w-6/12 flex items-center">
                  <h2 class="font-bold">Management Goal</h2>
                </div>
                <div class="vx-col w-6/12 flex items-center">
                  <h2 class="font-bold">Control</h2>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 ">
                <div class="vx-col w-6/12 flex items-center">
                  <img draggable="false" src="https://cdn.discordapp.com/attachments/786318540449775666/786467419161100298/report.png" width="50" class="mr-4">
                  <h4 class="font-semibold">Easily differentiate between mobile devices and servers in reports</h4>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="input0">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12 flex items-center">
                  <img draggable="false" src="https://cdn.discordapp.com/attachments/786318540449775666/786467676192112640/door-key.png" width="50" class="mr-4">
                  <h4 class="font-semibold">Enforce password complexity requirements</h4>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="input1">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12 flex items-center">
                  <img draggable="false" src="https://cdn.discordapp.com/attachments/786318540449775666/786467757902135306/teacher.png" width="50" class="mr-4">

                  <h4 class="font-semibold">Determine if devices used by terminated employees are returned</h4>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="input2">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12 flex items-center">
                  <img draggable="false" src="https://cdn.discordapp.com/attachments/786318540449775666/786467913438724146/files.png" width="50" class="mr-4">

                  <h4 class="font-semibold">Identify which employees have access to sensitive file shares</h4>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="input3">

                  </vue-draggable-container>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>

  </div>
</template>

<script>

import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      //last_drag_error: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard'

      }
    }
  },
  methods: {
    startedDrag (x) {
      x.data.source.className += ' currently-dragging-standard'
      this.draggingCard = true
    },
    stoppedDrag () {
      this.draggingCard = false
    },
    sort (x) {
      const overContainer = x.data.dragEvent.data.overContainer
      const sourceContainer = x.data.dragEvent.data.sourceContainer
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel()
        }
      }
    },
    /*  drag_error () {
      const now = new Date().getTime()
      if (this.last_drag_error === false || (now - this.last_drag_error) > 7500) {
        this.last_drag_error = now
        this.$vs.notify(
          {
            color: 'warning',
            title: 'Maximum One Answer Per Input',
            position: 'top-center',
            icon: 'feather',
            iconPack: 'icon-alert-circle',
          })
      }
    }, */
    markSimulation () {

      let total_score = 0

      if (document.getElementById('input0').textContent === 'Standard Naming Convention') {
        document.getElementById('input0').style.borderColor = '#28C76F'
        document.getElementById('input0').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input0').style.borderColor = '#fd4445'
        document.getElementById('input0').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input1').textContent  === 'Group Policy') {
        document.getElementById('input1').style.borderColor = '#28C76F'
        document.getElementById('input1').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input1').style.borderColor = '#fd4445'
        document.getElementById('input1').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input2').textContent  === 'Off-Boarding Procedures') {
        document.getElementById('input2').style.borderColor = '#28C76F'
        document.getElementById('input2').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input2').style.borderColor = '#fd4445'
        document.getElementById('input2').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input3').textContent  === 'Permission Auditing and Review') {
        document.getElementById('input3').style.borderColor = '#28C76F'
        document.getElementById('input3').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input3').style.borderColor = '#fd4445'
        document.getElementById('input3').style.backgroundColor = '#fd4445'
      }

      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    }

  },
  components: {
    draggable,
    Prism
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>

